import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="bg-cream py-20 md:py-28 px-4" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="relative" data-id="element-60">
          {/* Decorative line */}
          <div className="w-24 h-px bg-gold mx-auto mb-12" data-id="element-61" />

          <div className="prose prose-lg md:prose-xl text-brown mx-auto font-sans leading-relaxed" data-id="element-62">
            <p className="mb-6" data-id="element-63">
              <span className="float-left text-6xl md:text-7xl font-serif text-gold leading-none pr-3 pt-2" data-id="element-64">
                ¿
              </span>
              <strong data-id="element-65">
                Has sentido alguna vez que estás atrapado entre dos mundos?
              </strong>{' '}
              Por un lado, sabes que tienes un talento que Dios te dio. Por
              otro, las facturas en EE.UU. no esperan, el cansancio del empleo
              actual te agota y sientes que estás "vendiendo tu vida" por un
              cheque que apenas alcanza.
            </p>
            <p data-id="element-66">
              Has orado por una salida, pero la pregunta sigue ahí:{' '}
              <em data-id="element-67">
                ¿Cómo paso de la oración a un negocio real que funcione en este
                país?
              </em>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}